let configint = "";

const prod = {
  url: {
    API_URL: "https://api.juvo.com.br/localizacao",
    TOKEN: "51F6FD62D2AB2EEBC0BB9239B1311790",
    CHAVE: "JUVO_ADM",
    ID_CLIENTECORPORATIVO: "",
    AUTHORIZATION: "Bearer 0fad8581-3cb5-3eec-86c4-2fee7c0e61ff",
    CONTEXT: "/"
  },
  urlEnd: {
    API_URL: "https://api.juvo.com.br/utils/endereco",
    TOKEN: "51F6FD62D2AB2EEBC0BB9239B1311790",
    CHAVE: "JUVO_ADM",
    IDCLIENTECORPORATIVO: "4",
    AUTHORIZATION: "Bearer 0fad8581-3cb5-3eec-86c4-2fee7c0e61ff",
    CONTEXT: "/"
  },
  dadosMap: {
    CLIENT: "gme-usssolucoesgerenciadas",
    LANGUAGE: "pt-BR"
  }
};

const hml = {
  url: {
    API_URL: "https://api-hml.juvo.com.br/localizacao",
    TOKEN: "51F6FD62D2AB2EEBC0BB9239B1311790",
    CHAVE: "JUVO_ADM",
    ID_CLIENTECORPORATIVO: "",
    AUTHORIZATION: "Bearer a46bef42-c8b0-340a-b026-d871e386b3a2",
    CONTEXT: "/"
  },
  urlEnd: {
    API_URL: "https://api-hml.juvo.com.br/utils/1.0.1/endereco",
    TOKEN: "E87A7FE5CE5DC6326F76AF386D320B05",
    CHAVE: "TEMPOPREMIUM",
    IDCLIENTECORPORATIVO: "421",
    AUTHORIZATION: "Bearer a46bef42-c8b0-340a-b026-d871e386b3a2",
    CONTEXT: "/"
  },
  dadosMap: {
    CLIENT: "gme-usssolucoesgerenciadas",
    LANGUAGE: "pt-BR"
  }
};

const dev = {
  url: {
    //API_URL: 'https://cors-anywhere.herokuapp.com//http://10.5.4.216:8080',
    //API_URL: 'http://10.5.4.216:8081',
    API_URL: "https://api-hml.juvo.com.br",
    API_URL: 'http://localhost:8082/juvo-service',
    TOKEN: "51F6FD62D2AB2EEBC0BB9239B1311790",
    CHAVE: "JUVO_ADM",
    ID_CLIENTECORPORATIVO: "",
    AUTHORIZATION: "Bearer 0fad8581-3cb5-3eec-86c4-2fee7c0e61ff",
    CONTEXT: "/"
  },
  urlEnd: {
    API_URL: "https://api-hml.juvo.com.br/utils/1.0.1/endereco",
    TOKEN: "E87A7FE5CE5DC6326F76AF386D320B05",
    CHAVE: "TEMPOPREMIUM",
    IDCLIENTECORPORATIVO: "421",
    AUTHORIZATION: "Bearer a46bef42-c8b0-340a-b026-d871e386b3a2",
    CONTEXT: "/"
  },
  dadosMap: {
    CLIENT: "gme-usssolucoesgerenciadas",
    LANGUAGE: "pt-BR"
  }
};

if (process.env.NODE_ENV === "development") {
  configint = dev;
} else if (process.env.NODE_ENV === "hml") {
  configint = hml;
} else {
  configint = prod;
}

//configint = hml;

export const config = configint;
